"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Z_INDEX = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Z_INDEX = exports.Z_INDEX = {
  ModalOverlay: 1500,
  ModalBox: 1501,
  ModalRoot: 1502,
  ModalCloseButton: 1505,
  Snackbar: 1499,
  Popover: 1501,
  Select: 1503,
  MediaActionsOverlay: 1504,
  MediaActions: 1505,
  Tooltip: 1505
};